import { SelectOption } from './types'
import { TargetProductClass } from './useTargetProductClassesData'

export const targetProductClassesToOption = () => (
  targetProductClass: TargetProductClass
): SelectOption => ({
  value: targetProductClass.id.toString(),
  label: targetProductClass.name,
})
